/** @ts-ignore */
import { buildURI } from 'react-csv/lib/core';
import { LabelKeyObject } from 'react-csv/components/CommonPropTypes';

type CsvCell = string | number;
type CsvRow = CsvCell[];
type CsvDownloadOptions = {
  fileName: string;
  rows: CsvRow[];
};

type Headers = LabelKeyObject[];
type CsvData = Record<string, CsvCell>[];
type CsvDownloadOptionsWithHeaders = {
  headers: Headers;
  data: CsvData;
  fileName: string;
};

export const generateCsvFile = (csvDataUri: string, fileName: string) => {
  const downloadLink = document.createElement('a');
  downloadLink.href = csvDataUri;
  downloadLink.target = '_blank';
  downloadLink.download = fileName;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
};

export const downloadAsCsvFile = ({ rows, fileName }: CsvDownloadOptions) => {
  const csvDataUri: string = buildURI(rows, true, null, ',');
  return generateCsvFile(csvDataUri, fileName);
};

export const downloadAsCsvFileWithHeaders = ({
  data,
  headers,
  fileName,
}: CsvDownloadOptionsWithHeaders) => {
  const csvDataUri: string = buildURI(data, true, headers);
  return generateCsvFile(csvDataUri, fileName);
};
